import Accessor from '@arcgis/core/core/Accessor';
import { property, subclass } from '@arcgis/core/core/accessorSupport/decorators';
import Collection from '@arcgis/core/core/Collection';
import { whenDefinedOnce } from '@arcgis/core/core/watchUtils';
import PortalItem from '@arcgis/core/portal/PortalItem';
import request from "@arcgis/core/request";
import { getBaseUrl } from '../../utils/utils';

const INSTANT_APPS_FILTER_KEYWORD = "configurableApp";

@subclass('Landing.data.MyApps.MyAppsViewModel')
export default class MyAppsViewModel extends Accessor {
    @property() view: __esri.MapView | __esri.SceneView;

    @property() portal: __esri.Portal;

    @property() myApps: __esri.Collection<__esri.PortalItem>;

    @property() isMyAppsLoading: boolean = false;

    private _baseUrl: string;

    constructor(params?: any) {
        super(params);

        whenDefinedOnce(this, "portal", async (portal: __esri.Portal) => {
            await this.portal.load();
            this._baseUrl = getBaseUrl(this.portal);
            this._baseUrl = this._baseUrl.replace("http://", "https://");

            this.isMyAppsLoading = true;
            this.queryAllMyApps();
        });
    }

    async queryAllMyApps() {
        const appInfos = await this.queryMyApps();
        const loadedItems = appInfos
            .filter((item: any) => {
                // filter out all queried portalItems that don't have INSTANT_APPS_FILTER_KEYWORD in the typeKeywords
                return (item?.typeKeywords as string[])
                    ?.map(keyword => INSTANT_APPS_FILTER_KEYWORD === keyword)
                    ?.reduce((acc, curr) => acc || curr, false);
            }).map(async (info) => {
                const item = new PortalItem({ id: info.id, portal: this.portal });
                await item.load();
                return item;
            }).toArray();
        this.myApps = new Collection(await Promise.all(loadedItems));
        this.isMyAppsLoading = false;
    }

    async removeFromMyAppsOnDelete(id: string) {
        this.myApps = this.myApps.filter((myApp: __esri.PortalItem) => myApp.id !== id);
    }

    private async queryMyApps(): Promise<__esri.Collection<any>> {
        let qParams: any = {
            num: 100,
            q: `owner:"${this.portal.user.username}" AND type:"Web Mapping Application"`,
            f: "json"
        };
        let results: __esri.Collection<__esri.PortalItem> = new Collection();

        while (qParams.start !== -1) {
            const queryResult = await request(
                `${this._baseUrl}/sharing/rest/search`, {
                query: qParams,
                method: "auto",
                responseType: "json"
            });
            const { data } = queryResult;
            results.addMany(data.results);
            qParams.start = data.nextStart;
        }

        return results;
    }

}
